import React from 'react';
import { FiChevronRight, FiRefreshCw, FiCheck, FiX } from 'react-icons/fi';
import { TooltipTop } from '@components/tooltips';
import { AirflowTaskInstance } from '../types';
import { formatDateTime, TaskInstanceStateBadge } from '../utils';
import styles from '../styles.module.scss';

type TaskInstanceHeaderProps = {
    dagId: string;
    runId: string;
    taskId: string;
    taskInstance: AirflowTaskInstance | null;
    isLoading: boolean;
    onClear: () => void;
    onMarkSuccess: () => void;
    onMarkFailed: () => void;
};

/*
 * DAG-run-task detail header: breadcrumb, state + actions, and a small meta grid
 */
export function TaskInstanceHeader({ dagId, runId, taskId, taskInstance, isLoading, onClear, onMarkSuccess, onMarkFailed }: TaskInstanceHeaderProps) {
    return (
        <div>
            <div className={styles.breadcrumb}>
                <span style={{ fontFamily: 'monospace' }}>{dagId}</span>
                <FiChevronRight />
                <span style={{ fontFamily: 'monospace' }}>{runId}</span>
                <FiChevronRight />
                <span style={{ fontFamily: 'monospace' }}>{taskId}</span>
            </div>
            {isLoading || !taskInstance ? (
                <div className={styles.headerRow}>
                    <h1>{taskId}</h1>
                </div>
            ) : (
                <>
                    <div className={styles.headerRow}>
                        <h1>
                            {taskInstance.task_display_name ?? taskId}
                            <TaskInstanceStateBadge state={taskInstance.state} />
                        </h1>
                        <div style={{ display: 'flex', gap: 16 }}>
                            <TooltipTop title="Clear">
                                <span className={styles.actionIcon} onClick={onClear}>
                                    <FiRefreshCw />
                                </span>
                            </TooltipTop>
                            <TooltipTop title="Mark Success">
                                <span className={styles.actionIcon} onClick={onMarkSuccess}>
                                    <FiCheck />
                                </span>
                            </TooltipTop>
                            <TooltipTop title="Mark Failed">
                                <span className={styles.actionIcon} onClick={onMarkFailed}>
                                    <FiX />
                                </span>
                            </TooltipTop>
                        </div>
                    </div>
                    <div className={styles.metaGrid}>
                        <div className={styles.metaField}>
                            <div className={styles.metaLabel}>Operator</div>
                            <div className={styles.metaValue}>{taskInstance.operator_name ?? taskInstance.operator ?? '—'}</div>
                        </div>
                        <div className={styles.metaField}>
                            <div className={styles.metaLabel}>Start Date</div>
                            <div className={styles.metaValue}>{formatDateTime(taskInstance.start_date)}</div>
                        </div>
                        <div className={styles.metaField}>
                            <div className={styles.metaLabel}>End Date</div>
                            <div className={styles.metaValue}>{formatDateTime(taskInstance.end_date)}</div>
                        </div>
                        <div className={styles.metaField}>
                            <div className={styles.metaLabel}>Try Number</div>
                            <div className={styles.metaValue}>{taskInstance.try_number ?? 1}</div>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
}
